import React from 'react';
import { Star, Download, Zap } from 'lucide-react';
import { useGeoPrice } from '../../hooks/useGeoPrice';
const cases = [{
  num: 1,
  title: 'EL VENENO SILENCIOSO',
  color: '#1a0a0a'
}, {
  num: 2,
  title: 'LA HERENCIA MALDITA',
  color: '#0a0a1a'
}, {
  num: 3,
  title: 'MUERTE EN EL TREN',
  color: '#0a1a0a'
}, {
  num: 4,
  title: 'EL ÚLTIMO TESTIGO',
  color: '#1a1a0a'
}];
function CaseFolder({
  num,
  title,
  color,
  rotate
}: {
  num: number;
  title: string;
  color: string;
  rotate: string;
}) {
  return <div className="relative rounded-sm shadow-2xl" style={{
    width: '130px',
    height: '170px',
    backgroundColor: '#d4a853',
    transform: `rotate(${rotate})`,
    transformOrigin: 'bottom center',
    border: '1px solid #b8922f'
  }} data-id="element-135">
      {/* Folder tab */}
      <div className="absolute -top-3 left-3 rounded-t-sm" style={{
      width: '50px',
      height: '14px',
      backgroundColor: '#b8922f'
    }} data-id="element-136" />
      {/* Header stripe */}
      <div className="w-full flex items-center justify-center py-2" style={{
      backgroundColor: '#8b0000',
      borderBottom: '2px solid #6b0000'
    }} data-id="element-137">
        <span className="text-white text-xs font-bold tracking-widest" data-id="element-138">
          CASO {num}
        </span>
      </div>
      {/* Content area */}
      <div className="p-2 flex flex-col gap-1" data-id="element-139">
        <div className="w-full h-0.5 opacity-30" style={{
        backgroundColor: '#8b6914'
      }} data-id="element-140" />
        <div className="w-3/4 h-0.5 opacity-30" style={{
        backgroundColor: '#8b6914'
      }} data-id="element-141" />
        <div className="w-full h-0.5 opacity-30 mt-1" style={{
        backgroundColor: '#8b6914'
      }} data-id="element-142" />
        <div className="w-2/3 h-0.5 opacity-30" style={{
        backgroundColor: '#8b6914'
      }} data-id="element-143" />
      </div>
      {/* Confidential stamp */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 px-2 py-0.5 text-center" style={{
      border: '2px solid #c0392b',
      color: '#c0392b',
      fontSize: '0.5rem',
      fontWeight: 900,
      letterSpacing: '0.15em',
      transform: 'translateX(-50%) rotate(-12deg)',
      opacity: 0.9,
      whiteSpace: 'nowrap'
    }} data-id="element-144">
        CONFIDENCIAL
      </div>
      {/* Case title */}
      <div className="absolute bottom-1 left-0 right-0 text-center px-1" style={{
      fontSize: '0.45rem',
      color: '#5a3e0a',
      fontWeight: 700,
      letterSpacing: '0.05em'
    }} data-id="element-145">
        {title}
      </div>
    </div>;
}
function StarRating({
  rating
}: {
  rating: number;
}) {
  return <div className="flex items-center gap-0.5" data-id="element-146">
      {[1, 2, 3, 4, 5].map(i => <Star key={i} size={16} fill={i <= Math.floor(rating) ? '#f0c040' : i - 0.5 <= rating ? '#f0c040' : 'none'} stroke="#f0c040" strokeWidth={1.5} data-id="element-147" />)}
    </div>;
}
export function HeroSection() {
  const {
    price,
    loading
  } = useGeoPrice();
  return <section className="relative overflow-hidden pt-6 pb-8 px-6" style={{
    backgroundColor: '#000000'
  }} data-id="element-148">
      <div className="relative z-10 max-w-2xl mx-auto flex flex-col items-center text-center gap-5" data-id="element-149">
        {/* Tagline */}
        <p className="text-3xl sm:text-4xl md:text-5xl font-black leading-tight text-white" style={{
        fontFamily: "'Inter', sans-serif"
      }} data-id="element-150">
          🔍 En{' '}
          <span style={{
          color: '#c0392b'
        }} data-id="element-151">
            1 minuto
          </span>{' '}
          lo descargás,
          <br data-id="element-152" />
          en{' '}
          <span style={{
          color: '#f0c040'
        }} data-id="element-153">
            2 horas
          </span>{' '}
          vivís el plan más distinto
        </p>

        {/* Case image */}
        <div className="w-full flex justify-center my-2" data-id="element-154">
          <img src="https://cdn.magicpatterns.com/uploads/eC4mDw1gGW3fqvDkdtMe2C/ChatGPT_Image_24_oct_2025_10_29_01_61418507-ed99-4b88-87b4-1484f7186074.webp" alt="4 casos confidenciales - HOY 4 AL PRECIO DE 1" className="w-full max-w-xs sm:max-w-sm rounded-xl shadow-2xl" style={{
          objectFit: 'contain',
          display: 'block'
        }} loading="eager" fetchPriority="high" width={384} height={384} data-id="element-155" />
        </div>

        {/* Main title */}
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white leading-tight" style={{
        fontFamily: "'Playfair Display', serif",
        letterSpacing: '-0.01em'
      }} data-id="element-156">
          <span className="block text-sm sm:text-base font-bold tracking-widest uppercase mb-2" style={{
          color: '#c0392b',
          fontFamily: "'Inter', sans-serif",
          letterSpacing: '0.18em'
        }} data-id="element-157">
            SOLO POR HOY 🎁
          </span>
          4X1 EN JUEGOS DE
          <br data-id="element-158" />
          INVESTIGACIÓN
          <br data-id="element-159" />
          <span style={{
          color: '#c0392b'
        }} data-id="element-160">
            CASOS CRIMINALES
          </span>
        </h1>

        {/* Stars */}
        <div className="flex items-center gap-3" data-id="element-161">
          <StarRating rating={4.5} data-id="element-162" />
          <span className="text-sm text-gray-300" data-id="element-163">
            <span style={{
            color: '#f0c040'
          }} className="font-bold" data-id="element-164">
              4.9/5
            </span>{' '}
            ·{' '}
            <a href="#resenas" className="underline hover:text-white transition-colors" style={{
            color: '#f0c040'
          }} data-id="element-165">
              (176 reseñas)
            </a>
          </span>
        </div>

        {/* Price */}
        <div className="flex items-center gap-4" data-id="element-166">
          {loading ? <div className="h-12 w-40 rounded animate-pulse bg-gray-800" data-id="element-167" /> : <>
              <div className="text-center" data-id="element-168">
                <span className="text-gray-500 line-through text-lg block" data-id="element-169">
                  {price.compareAt} {price.currency}
                </span>
              </div>
              <span className="text-5xl font-black" style={{
            color: '#f0c040',
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-170">
                {price.current} {price.currency}
              </span>
              <span className="px-3 py-1 text-sm font-black text-white rounded" style={{
            backgroundColor: '#c0392b'
          }} data-id="element-171">
                {price.discount}
              </span>
            </>}
        </div>

        {/* CTA Button */}
        <a href="https://www.resuelvecasos.online/cart/47736555077876:1" target="_blank" rel="noopener noreferrer" onClick={() => {
        ;
        (window as any).fbq?.('track', 'AddToCart');
      }} className="w-full sm:w-auto flex items-center justify-center gap-3 px-10 py-4 text-lg font-black text-white rounded-lg transition-all hover:opacity-90 active:scale-95 shadow-lg" style={{
        backgroundColor: '#c0392b',
        boxShadow: '0 0 40px rgba(192,57,43,0.5)',
        letterSpacing: '0.06em'
      }} data-id="element-172">
          <Download size={22} data-id="element-173" />
          DESCARGAR AHORA — OFERTA 4x1
        </a>
      </div>
    </section>;
}